var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterNewpost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1974 0.919769H6.78447C3.16205 0.919769 0.884766 3.48826 0.884766 7.11713V16.9199C0.884766 20.5487 3.15025 23.1054 6.78447 23.1054H17.1916C20.8376 23.1054 23.0913 20.5487 23.0913 16.9199V12.207",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0586 10.4977L16.8728 1.69657C17.1336 1.43545 17.4435 1.22826 17.7847 1.0869C18.1259 0.945548 18.4916 0.872894 18.861 0.872894C19.2303 0.872894 19.5961 0.945548 19.9373 1.0869C20.2784 1.22826 20.5883 1.43545 20.8492 1.69657L22.2887 3.13395C22.5502 3.39442 22.7577 3.70397 22.8992 4.04464C23.0408 4.3853 23.1137 4.75046 23.1137 5.11929C23.1137 5.48811 23.0408 5.85327 22.8992 6.19394C22.7577 6.5346 22.5502 6.84401 22.2887 7.10448L13.4274 15.9528C13.1901 16.1889 12.9084 16.3761 12.5987 16.5035C12.2889 16.6309 11.957 16.6959 11.622 16.6951H7.19727L7.30346 12.2416C7.3251 11.5858 7.59494 10.9626 8.0586 10.4977V10.4977Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5273 3.06332L20.9197 8.43586",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterNewpost);
export default __webpack_public_path__ + "static/media/footer_newpost.4011ae0d23998e4677c39ff62cf5d11e.svg";
export { ForwardRef as ReactComponent };